import React from 'react';
import { Layout } from '@storable/canaveral-components';
import BuilderPagesDropdown from 'admin/components/BuilderPagesDropdown';
import BuilderLanguagesMenu from '../containers/BuilderLanguagesMenu';
import BuilderPageDraftButton from '../containers/BuilderPageDraftButton';
import BuilderHeader from './BuilderHeader';
import BuilderVersionSwitchButton from '../containers/BuilderVersionSwitchButton';

const { Header } = Layout;

const propTypes = {};

const defaultProps = {};

const BuilderPageHeader = () => (
  <BuilderHeader
    title="Page Builder"
    controls={<BuilderPageDraftButton />}
  >
    <Header.Group bordered>
      <BuilderLanguagesMenu />
    </Header.Group>
    <Header.Group bordered>
      <BuilderPagesDropdown />
    </Header.Group>
    <Header.Group bordered>
      <BuilderVersionSwitchButton />
    </Header.Group>
  </BuilderHeader>
);

BuilderPageHeader.propTypes = propTypes;
BuilderPageHeader.defaultProps = defaultProps;

export default BuilderPageHeader;
